import React,{useState} from 'react'
import './AddExpenseForm.css';
import { Button, TextField } from '@mui/material';

const button_styles = {width:'160px',margin:'0 1rem',color:'white',fontFamily:'Raleway',fontSize:'1rem',fontWeight:700,letterSpacing:'0.1px',height:'35px',borderRadius:'10px'};

const AddExpenseForm = ({handleAddItem}) => {
    const [fileURL, setFileURL] = useState(null);
    const [addForm, setAddForm] = useState({});


    return (
    <div className='add-item-form-container'>
        <div className='add-item-preview'>
            <h3>Preview</h3>
            <embed src={fileURL} type="application/pdf" />
        </div>
        <form className='add-item-form'>
            <span className='add-form-cell2'>
                <label>Expense Name</label>
                <TextField 
                    type='text'
                    size='small'
                    value={addForm.expense_name}
                    onChange={(e)=>{setAddForm({...addForm,expense_name:e.target.value})}}
                    sx={{width:'300px'}}
                />
            </span>
            <span className='add-form-cell2'>
                <label>Description</label>
                <TextField 
                    type='text'
                    size='small'
                    value={addForm.expense_description}
                    onChange={(e)=>{setAddForm({...addForm,expense_description:e.target.value})}}
                    sx={{width:'300px'}}
                />
            </span>
            <span className='add-form-cell2'>
                <label>Company Name</label>
                <TextField 
                    type='text'
                    size='small'
                    value={addForm.expense_business}
                    onChange={(e)=>{setAddForm({...addForm,expense_business:e.target.value})}}
                    sx={{width:'300px'}}
                />
            </span>
            <div className='add-form-buttons'>
                <div className='add-form-file'>
                    <Button variant='contained' sx={{...button_styles,background:'#76BFF3',"&:hover":{background:'#76BFF3'}}}>
                        <input className='upload-button' onChange={(e) => {
                            const file = e.target.files[0];
                            setAddForm({...addForm,image:file,pdf:null}); 
                            const file_url = URL.createObjectURL(file);
                            setFileURL(file_url);
                            }} type='file' accept='image/*' 
                            files = {[addForm.image]} />
                        Upload Image
                    </Button>
                    <h3>OR</h3>
                    <Button variant='contained' sx={{...button_styles,background:'#76BFF3',"&:hover":{background:'#76BFF3'}}}>
                        <input className='upload-button' onChange={(e) => {
                            const file = e.target.files[0];
                            setAddForm({...addForm,pdf:file,image:null}); 
                            const file_url = URL.createObjectURL(file);
                            setFileURL(file_url);
                            }} type='file' accept='application/pdf'
                            files = {[addForm.file]} />
                        Upload Pdf
                    </Button>
                </div>
                <Button onClick={(e) => handleAddItem(e,addForm)} variant='contained' sx={{...button_styles,background:'#76F4B5',"&:hover":{background:'#76F4B5'}}}>Submit</Button>
            </div>
        </form>
    </div>
  )
}

export default AddExpenseForm